<!--
 * @Description: 通知公告 添加
 * @Author: ZSC
 * @Date: 2023-04-18 16:14:18.627
 * @LastEditors: PF
 * @LastEditTime: 2025-07-17 15:26:30
-->
<template>
  <div>
    <el-dialog class="w800 h630" :model-value="openAdd" :close-on-click-modal="false" :show-close="false"
      destroy-on-close>
      <template #header>
        <div class="header-left">
          <el-icon class="header-icon">
            <Edit />
          </el-icon>
          <span class="header-title">添加</span>
        </div>
        <div class="header-right">
          <el-button type="info" text @click="closeWindow('openAdd', emits, false)">
            <el-icon>
              <Close />
            </el-icon>
          </el-button>
        </div>
      </template>
      <el-form ref="ruleFormRef" :model="ruleForm" label-width="80px">
        <el-row>
          <el-col :span="24" v-if="ruleForm.gglx===1">
            <el-form-item label="通知成员" prop="tzcy" :rules="[{ required: true, message: '必填项', trigger: 'blur' }]">
              <el-select v-model="ruleForm.tzcy" clearable filterable :teleported="false" @change="tongZhiChengYuanChange()">
                <el-option v-for="item in tzcyData.list" :key="item.value" :label="item.label" :value="item.value" />
              </el-select>
              <el-row class="wp100" v-if="listData">
                <el-col :span="8" v-for="(item, index) in listData" :key="index" class="mt10">
                  <el-tag type="primary" class="w140" size="large">{{item.name.length > 8 ? item.name.substring(0, 7) + '...' :  item.name}}</el-tag>
                  <el-text class="w30 ml5 mr5" type="warning">{{item.typeName}}</el-text>
                  <el-link type="danger" :underline="false" @click="delUser(index)"><span class="iconfont icon-shanchu"></span></el-link>
                </el-col>
              </el-row>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="标题" prop="bt" :rules="[{ required: true, message: '必填项', trigger: 'blur' }]">
              <el-input v-model="ruleForm.bt" />
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="发布机构" prop="fbjgid" :rules="[{ required: true, message: '必填项', trigger: 'blur' }]">
              <el-select v-model="ruleForm.fbjgid" clearable filterable>
                <el-option v-for="item in fbjgData" :key="item.id" :label="item.jgmc" :value="item.id" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="内容" prop="nr" :rules="[{ required: true, message: '必填项', trigger: 'blur' }]">
              <teditor ref="editor" v-model="ruleForm.nr" :height="350" />
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="上传附件" prop="fjs">
              <p style="color:#F56C6C;line-height: 33px;">单次最大上传10个文件，上传插件所支持的格式有（png,jpg,doc,xlx,xls,pdf）上传资源</p>
              <el-upload style="width:100%" class="upload-demo" drag multiple accept=".png,.jpg,.doc,.xlx,.xls,.pdf" :show-file-list="false" :http-request="importClick" :limit="10" >
                <el-icon class="el-icon--upload">
                  <upload-filled />
                </el-icon>
                <div class="el-upload__text">
                  将文件拖到此处，或 <em>点击上传</em>
                </div>
              </el-upload>
              <el-progress v-if="isProgress" class="wp100" :percentage="percentage"></el-progress>
              <div class="fujian wp100" v-for="(item,index) in fjList" :key="item.fjdz">
                <el-link :href="baseurl+item.fjdz" target="_blank" type="primary">{{item.fjmc}}</el-link>
                <el-link class="ml10" type="danger" @click="fuJianDel(index)"><span class="iconfont icon-shanchu"></span></el-link>
              </div>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <template #footer>
        <div class="dialog-footer">
          <div></div>
          <div class="footer_but">
            <el-button type="primary" @click="submit()">保存</el-button>
            <el-button type="info" @click="closeWindow('openAdd', emits, false)">关闭</el-button>
          </div>
        </div>
      </template>
    </el-dialog>
  </div>
  <jiaozhigongduotiao v-if="openJiaoShiDuoTiao" v-model:openDuoTiao="openJiaoShiDuoTiao" :row="row" @ReturnData="ReturnData" />
  <zhiwuduotiao v-if="openZhiWuDuoTiao" v-model:openDuoTiao="openZhiWuDuoTiao" :row="row" @ReturnData="ReturnData" />
  <bumenduotiao v-if="openBuMenDuoTiao" v-model:openDuoTiao="openBuMenDuoTiao" :row="row" @ReturnData="ReturnData" />
  <banjiduotiao v-if="openBanJiDuoTiao" v-model:openDuoTiao="openBanJiDuoTiao" :row="row" @ReturnData="ReturnData" />
  <xueshengduotiao v-if="openXueShengDuoTiao" v-model:openDuoTiao="openXueShengDuoTiao" :row="row" @ReturnData="ReturnData" />
</template>

<script setup>
import axios from 'axios'
import { defineProps, defineEmits, ref, watch, unref } from 'vue'
import { submitForm, closeWindow, loadSelect } from '@/api/common.js'
import { getTzcy } from '@/utils/meiju.js'
import teditor from '@/components/teditorwanzheng.vue'
import jiaozhigongduotiao from '@/components/chazhaodaihui/jiaozhigongduotiao.vue'
import zhiwuduotiao from '@/components/chazhaodaihui/zhiwuduotiao.vue'
import bumenduotiao from '@/components/chazhaodaihui/bumenduotiao.vue'
import banjiduotiao from '@/components/chazhaodaihui/banjiduotiao.vue'
import xueshengduotiao from '@/components/chazhaodaihui/xueshengduotiao.vue'

const props = defineProps({
  openAdd: { type: Boolean, required: true },
  row: { type: Object, required: false }
})
const emits = defineEmits(['update:openAdd', 'ReturnData'])

const ruleFormRef = ref(null)
const ruleForm = ref({})

const row = ref()
const typeName = ref({ 1: '教师', 2: '职务', 3: '部门', 4: '教师', 5: '学生', 6: '班级', 7: '学生', 8: '全体' })

const listData = ref([])

const openJiaoShiDuoTiao = ref(false) // 指定教师
const openZhiWuDuoTiao = ref(false) // 指定职务
const openBuMenDuoTiao = ref(false) // 指定部门
const openBanJiDuoTiao = ref(false) // 指定班级
const openXueShengDuoTiao = ref(false) // 指定学生

const setFalse = () => {
  openJiaoShiDuoTiao.value = false
  openZhiWuDuoTiao.value = false
  openBuMenDuoTiao.value = false
  openBanJiDuoTiao.value = false
  openXueShengDuoTiao.value = false
}

// 选择通知成员
const tongZhiChengYuanChange = () => {
  setFalse()
  let list = []
  list = listData.value ? listData.value.filter(item => item.type === ruleForm.value.tzcy) : []
  row.value = { ids: list.map(item => item.id) }
  switch (ruleForm.value.tzcy) {
    case 1: // 指定教师
      openJiaoShiDuoTiao.value = true
      break
    case 2: // 指定职务
      openZhiWuDuoTiao.value = true
      break
    case 3: // 指定部门
      openBuMenDuoTiao.value = true
      break
    case 4: // 所有教师
      listData.value.push({ id: ruleForm.value.tzcy, name: '所有教师', type: ruleForm.value.tzcy, typeName: typeName.value[ruleForm.value.tzcy] })
      break
    case 5: // 所有学生
      listData.value.push({ id: ruleForm.value.tzcy, name: '所有学生', type: ruleForm.value.tzcy, typeName: typeName.value[ruleForm.value.tzcy] })
      break
    case 6: // 指定班级
      openBanJiDuoTiao.value = true
      break
    case 7: // 指定学生
      openXueShengDuoTiao.value = true
      break
    case 8: // 所有师生
      listData.value.push({ id: ruleForm.value.tzcy, name: '全校师生', type: ruleForm.value.tzcy, typeName: typeName.value[ruleForm.value.tzcy] })
      break
  }
}

const ReturnData = (data) => {
  let list = []
  switch (ruleForm.value.tzcy) {
    case 1: // 指定教师
      list = data.map(item => ({ id: item.id, name: item.xm }))
      break
    case 2: // 指定职务
      list = data.map(item => ({ id: item.id, name: item.zwmc }))
      break
    case 3: // 指定部门
      list = data.map(item => ({ id: item.id, name: item.jgmc }))
      break
    case 6: // 指定班级
      list = data.map(item => ({ id: item.id, name: item.xzbmc }))
      break
    case 7: // 指定学生
      list = data.map(item => ({ id: item.id, name: item.xm }))
      break
  }
  list.forEach(e => {
    listData.value.push({ id: e.id, name: e.name, type: ruleForm.value.tzcy, typeName: typeName.value[ruleForm.value.tzcy] })
  })
}
const delUser = (index) => {
  listData.value.splice(index, 1)
}

const fbjgData = ref([])
const tzcyData = ref({ list: [] })

// 资源文件上传
const baseurl = ref(process.env.VUE_APP_BASE_API)// 根路径
const fjList = ref([])
const isProgress = ref(false)
const percentage = ref(0)
const importClick = async (file) => {
  const fileSuffix = file.file.name.substring(
    file.file.name.lastIndexOf('.') + 1
  )
  // 检测违规格式 开始
  const whiteList = ['exe', 'com', 'bat', 'scr']
  const isSuffix = whiteList.includes(fileSuffix.toLowerCase())
  if (isSuffix) {
    return warningPrompt('禁止上传 ' + whiteList + ' 格式文件')
  }
  // // 检测违规格式 结束
  const formData = new FormData()
  formData.append('file', file.file)
  formData.append('fwjjmc', 'public')
  formData.append('wjjmc', 'zzsw') // 文件地址类别 /common/cyrcglCpgl/202210/18/1.jpg
  axios({
    url: process.env.VUE_APP_BASE_API + '/api/v2/sys/wenjian/upload',
    data: formData,
    method: 'post',
    headers: {
      'Content-Type': 'application/json',
      accesscode: $cookies.get(process.env.VUE_APP_BASE_TOKEN)
    },
    // 上传进度
    onUploadProgress: (progressEvent) => {
      if (progressEvent.lengthComputable) {
        isProgress.value = true
        // 是否存在进度
        const percentCompleted = Math.round(
          (progressEvent.loaded * 100) / progressEvent.total
        )
        percentage.value = percentCompleted
        if (percentCompleted === 100) {
          isProgress.value = true
        }
      }
    }
  }).then((res) => {
    const obj = {
      fjmc: res.data.data.ymc,
      fjdz: res.data.data.lj + res.data.data.mc,
      id: res.data.data.id
    }
    fjList.value.push(obj)
  })
}
// 删除附件
const fuJianDel = (ind) => {
  fjList.value.splice(ind, 1)
}

watch(
  () => props.openAdd,
  () => {
    if (props.openAdd) {
      tzcyData.value = getTzcy()
      ruleForm.value.gglx = props.row.gglx
      loadSelect({ url: '/api/v2/bangong/tongzhigonggao/quanxian/shouye/bumentongzhi', data: fbjgData })
    }
  },
  { deep: true, immediate: true }
)

// 提交
const submit = async () => {
  ruleForm.value.listjiaoshiid = []
  ruleForm.value.listzhiwuid = []
  ruleForm.value.listbumenid = []
  ruleForm.value.listbanjiid = []
  ruleForm.value.listxueshengid = []
  ruleForm.value.listfujian = fjList.value.map((item) => item.fjdz)
  ruleForm.value.tzfwlx = listData.value.map(item => item.type).join(',')
  listData.value.forEach(element => {
    switch (element.type) {
      case 1: // 指定教师
        ruleForm.value.listjiaoshiid.push(element.id)
        break
      case 2: // 指定职务
        ruleForm.value.listzhiwuid.push(element.id)
        break
      case 3: // 指定部门
        ruleForm.value.listbumenid.push(element.id)
        break
      case 6: // 指定班级
        ruleForm.value.listbanjiid.push(element.id)
        break
      case 7: // 指定学生
        ruleForm.value.listxueshengid.push(element.id)
        break
    }
  })
  submitForm({
    url: '/api/v2/bangong/tongzhigonggao/shouYe/insert',
    ruleFormRef: unref(ruleFormRef),
    ruleForm: ruleForm.value,
    callback: function () {
      closeWindow('openAdd', emits, true)
    }
  })
}
</script>
